module.exports = __webpack_public_path__ + "static/assets/a9ae5a704790cef0c3d5456c3bd4a7c9.png";